/**
 * @generated SignedSource<<d0a56c51e49479c9bee500520ca9a928>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateCustomerMutation$variables = {
  address?: string | null;
  address2?: string | null;
  categoryId?: string | null;
  city?: string | null;
  id: string;
  key: string;
  name: string;
  state?: string | null;
  status?: string | null;
  zip?: string | null;
};
export type UpdateCustomerMutation$data = {
  readonly updateCustomer: {
    readonly address: string | null;
    readonly address2: string | null;
    readonly categoryId: string | null;
    readonly city: string | null;
    readonly id: string;
    readonly key: string;
    readonly name: string;
    readonly state: string | null;
    readonly status: string | null;
    readonly zip: string | null;
  };
};
export type UpdateCustomerMutation = {
  response: UpdateCustomerMutation$data;
  variables: UpdateCustomerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "address"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "address2"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categoryId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "city"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "state"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "zip"
},
v10 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "address",
            "variableName": "address"
          },
          {
            "kind": "Variable",
            "name": "address2",
            "variableName": "address2"
          },
          {
            "kind": "Variable",
            "name": "categoryId",
            "variableName": "categoryId"
          },
          {
            "kind": "Variable",
            "name": "city",
            "variableName": "city"
          },
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          },
          {
            "kind": "Variable",
            "name": "key",
            "variableName": "key"
          },
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          },
          {
            "kind": "Variable",
            "name": "state",
            "variableName": "state"
          },
          {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
          },
          {
            "kind": "Variable",
            "name": "zip",
            "variableName": "zip"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "Customer",
    "kind": "LinkedField",
    "name": "updateCustomer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "categoryId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "address",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "address2",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "city",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "zip",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateCustomerMutation",
    "selections": (v10/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v7/*: any*/),
      (v9/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpdateCustomerMutation",
    "selections": (v10/*: any*/)
  },
  "params": {
    "cacheID": "c51f0a815e2ea5fc62a4f77380754c2f",
    "id": null,
    "metadata": {},
    "name": "UpdateCustomerMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateCustomerMutation(\n  $id: ID!\n  $key: String!\n  $name: String!\n  $categoryId: ID\n  $address: String\n  $address2: String\n  $city: String\n  $state: String\n  $zip: String\n  $status: String\n) {\n  updateCustomer(input: {id: $id, key: $key, name: $name, categoryId: $categoryId, address: $address, address2: $address2, city: $city, state: $state, zip: $zip, status: $status}) {\n    id\n    key\n    name\n    categoryId\n    address\n    address2\n    city\n    state\n    zip\n    status\n  }\n}\n"
  }
};
})();

(node as any).hash = "6becfc4370231c1568312dfb2176bcdb";

export default node;
